import { render, staticRenderFns } from "./SinglePartnerLogo.vue?vue&type=template&id=70cc86e2&scoped=true&"
import script from "./SinglePartnerLogo.vue?vue&type=script&lang=js&"
export * from "./SinglePartnerLogo.vue?vue&type=script&lang=js&"
import style0 from "./SinglePartnerLogo.vue?vue&type=style&index=0&id=70cc86e2&lang=scss&scoped=true&"
import style1 from "./SinglePartnerLogo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc86e2",
  null
  
)

export default component.exports